export const anmClassificationCatalogZhCN = {
  "sections": {
    "cri": {
      "label": "CRI",
      "subtitle": "1 - 风险分类"
    },
    "dpa": {
      "label": "DPA",
      "subtitle": "2 - 相关潜在损害"
    },
    "go": {
      "label": "运营管理",
      "subtitle": "3 - 运营管理"
    }
  },
  "grades": {
    "ct": {
      "fullTitle": "1.1 - 技术特征 - CT"
    },
    "ec": {
      "fullTitle": "1.2 - 维护状态 - EC"
    },
    "psb": {
      "fullTitle": "1.3 - 大坝安全计划 - PSB"
    },
    "dpa": {
      "fullTitle": "2 - 按相关潜在损害分类 - DPA（废弃物和尾矿）"
    },
    "go": {
      "fullTitle": "3 - 按运营管理分类"
    }
  },
  "columns": {
    "ctA": {
      "title": "高度"
    },
    "ctB": {
      "title": "主断面边坡平均坡度"
    },
    "ctC": {
      "title": "长度"
    },
    "ctD": {
      "title": "设计洪水流量"
    },
    "ctE": {
      "title": "压实控制"
    },
    "ctF": {
      "title": "是否存在内部排水"
    },
    "ctG": {
      "title": "基础"
    },
    "ctH": {
      "title": "施工方法"
    },
    "ctI": {
      "title": "监测仪器"
    },
    "ctJ": {
      "title": "大坝坝龄"
    },
    "ecK": {
      "title": "泄洪结构可靠性"
    },
    "ecL": {
      "title": "渗流"
    },
    "ecM": {
      "title": "变形与沉降"
    },
    "ecN": {
      "title": "边坡 / 坝面劣化"
    },
    "ecO": {
      "title": "地表排水"
    },
    "psbP": {
      "title": "设计文件"
    },
    "psbQ": {
      "title": "大坝安全团队的组织结构及专业人员资质"
    },
    "psbR": {
      "title": "安全检查和监测程序手册"
    },
    "psbS": {
      "title": "应急行动计划 PAE（监管机构要求时）"
    },
    "psbT": {
      "title": "监测仪器检查和监测报告以及安全分析报告"
    },
    "dpaA": {
      "title": "水库总库容"
    },
    "dpaB": {
      "title": "下游人口存在情况"
    },
    "dpaC": {
      "title": "环境影响"
    },
    "dpaD": {
      "title": "社会经济影响"
    },
    "goA": {
      "title": "已提交 RISR 稳定状态声明"
    },
    "goB": {
      "title": "已提交 RPSB 稳定状态声明"
    },
    "goC": {
      "title": "已提交符合性和可运行性声明"
    },
    "goD": {
      "title": "已提交检查摘要"
    },
    "goE": {
      "title": "是否存在 EdR"
    },
    "goF": {
      "title": "矿山大坝风险管理计划 — PGRBM"
    },
    "goG": {
      "title": "认证和/或行业标准"
    }
  },
  "options": {
    "ctA": {
      "score0": "高度 ≤ 15m",
      "score1": "15m < 高度 < 30m",
      "score4": "30m ≤ 高度 ≤ 60m",
      "score7": "高度 > 60m"
    },
    "ctB": {
      "score0": "平缓（≤ 1V:3H）或混凝土坝",
      "score3": "中等（1V:2H ≥ 坡度 > 1V:3H）",
      "score6": "陡峭（> 1V:2H）"
    },
    "ctC": {
      "score0": "长度 ≤ 50m",
      "score1": "50m < 长度 < 200m",
      "score2": "200 ≤ 长度 ≤ 600m",
      "score3": "长度 > 600m"
    },
    "ctD": {
      "score0": "CMP（可能最大洪水）或万年一遇洪水",
      "score2": "千年一遇洪水",
      "score5": "TR = 500 年",
      "score10": "TR 低于 500 年或未知/研究不可靠"
    },
    "ctE": {
      "score0": "存在文件证明压实控制符合设计，并证明施工期间进行了技术跟踪和控制",
      "score4": "存在岩土工程研究证明压实度符合设计",
      "score10": "未进行技术控制和/或无相关信息和/或压实不符合设计"
    },
    "ctF": {
      "score0": "排水按设计建造，或设计中无排水",
      "score4": "大坝完工后修建的纠正性排水",
      "score10": "排水系统不符合设计、不存在、未知、研究不可靠或无法运行"
    },
    "ctG": {
      "score0": "基础已按设计进行勘察",
      "score6": "基础已部分勘察",
      "score10": "基础未知/研究不可靠"
    },
    "ctH": {
      "score0": "一次建成",
      "score2": "下游法加高",
      "score5": "中线法加高",
      "score10": "上游法加高或未知"
    },
    "ctI": {
      "score0": "监测仪器符合技术设计",
      "score2": "监测仪器不符合设计，但正在安装仪器以满足设计要求",
      "score6": "监测仪器不符合设计，且没有安装仪器以满足设计要求的流程",
      "score8": "大坝未按设计要求设置监测仪器"
    },
    "ctJ": {
      "score1": "5 至 15 年之间",
      "score2": "15 至 30 年之间",
      "score3": "< 5 年或 > 30 年或无信息"
    },
    "ecK": {
      "score0": "土建结构维护良好并正常运行 /大坝不需要泄洪结构",
      "score3": "结构存在已识别问题，纠正措施正在实施",
      "score6": "结构存在已识别问题，未实施必要纠正措施，无运行限制且泄洪设施具备满负荷能力",
      "score10": "结构存在已识别问题，泄洪能力降低且无纠正措施"
    },
    "ecL": {
      "score0": "渗流完全由排水系统控制",
      "score3": "下游区域、坝面、边坡和坝肩存在潮湿或渗出，但稳定并受到监测",
      "score6": "下游区域、坝面、边坡或坝肩存在潮湿或渗出，且未实施必要纠正措施",
      "score10": "下游区域出现渗出并伴随物料带出、流量增加或所含物料渗入，可能危及结构安全"
    },
    "ecM": {
      "score0": "不存在可能危及结构安全的变形和沉降",
      "score2": "存在裂缝和沉陷，纠正措施正在实施",
      "score6": "存在裂缝和沉陷，未实施必要纠正措施",
      "score10": "存在裂缝、沉陷或滑移，可能危及结构安全"
    },
    "ecN": {
      "score0": "边坡和坝面不存在劣化",
      "score2": "边坡和坝面防护存在缺陷，有灌木植被",
      "score6": "表面侵蚀、钢筋外露、有乔木植被，未实施必要纠正措施。",
      "score10": "边坡存在明显凹陷、滑移、深侵蚀沟，可能危及结构安全"
    },
    "ecO": {
      "score0": "地表排水存在且可运行",
      "score2": "存在裂缝和/或淤积和/或沉陷，纠正措施正在实施",
      "score4": "存在裂缝和/或淤积和/或沉陷，未实施纠正措施",
      "score5": "地表排水不存在"
    },
    "psbP": {
      "score0": "施工设计和“竣工图”",
      "score2": "施工设计或“竣工图”",
      "score3": "“现状”设计",
      "score5": "基本设计",
      "score8": "概念设计",
      "score10": "无设计文件"
    },
    "psbQ": {
      "score0": "设有行政单位，并有负责大坝安全的合格技术专业人员，或该大坝不属于第 12.334/2010 号法律第 1 条唯一段第 I、II、III 或 IV 项所列情形",
      "score1": "拥有负责大坝安全的合格技术专业人员（自有或聘用）",
      "score3": "设有行政单位，但没有负责大坝安全的合格技术专业人员",
      "score6": "没有行政单位，也没有负责大坝安全的合格技术负责人"
    },
    "psbR": {
      "score0": "拥有检查、监测和运行程序手册，或该大坝不属于第 12.334/2010 号法律第 1 条唯一段第 I、II、III 或 IV 项所列情形",
      "score2": "仅拥有监测程序手册",
      "score4": "仅拥有检查程序手册",
      "score8": "没有监测和检查的手册或正式程序"
    },
    "psbS": {
      "score0": "拥有 PAE",
      "score2": "没有 PAE（监管机构未要求）",
      "score4": "PAE 正在编制中",
      "score8": "没有 PAE（监管机构要求时）"
    },
    "psbT": {
      "score0": "定期基于监测仪器发布检查和监测报告以及安全分析报告，或该大坝不属于第 12.334/2010 号法律第 1 条唯一段第 I、II、III 或 IV 项所列情形",
      "score2": "仅定期发布安全分析报告",
      "score4": "仅定期发布检查和监测报告",
      "score6": "仅定期发布目视检查报告",
      "score8": "未定期发布检查和监测报告以及安全分析报告"
    },
    "dpaA": {
      "score1": "非常小 ≤ 50 万 m³",
      "score2": "小：50 万至 500 万 m³",
      "score3": "中：500 万至 2500 万 m³",
      "score4": "大：2500 万至 5000 万 m³",
      "score5": "非常大 ≥ 5000 万 m³"
    },
    "dpaB": {
      "score0": "不存在 — 大坝下游受影响区域内不存在常住/居民或临时/通行人员",
      "score3": "较少 — 大坝下游受影响区域内不存在永久居住人员，但存在当地使用的乡村道路",
      "score5": "频繁 — 大坝下游受影响区域内不存在永久居住人员，但存在市级、州级或联邦公路或其他地点和/或有人员偶尔停留且可能受影响的设施",
      "score10": "存在 — 大坝下游受影响区域内存在永久居住人员，因此可能影响人的生命"
    },
    "dpaC": {
      "score0": "可忽略 — 大坝下游受影响区域已完全失去自然条件，结构仅按 ABNT NBR 10004 储存 II B 类惰性废物",
      "score2": "较低显著性 — 大坝下游受影响区域（无相关环境价值区域或特定立法保护的保护区（不含 APP），且仅按 ABNT NBR 10004 储存 II B 类惰性废物）",
      "score6": "显著 — 大坝下游受影响区域具有相关环境价值或特定立法保护的保护区（不含 APP），且仅按 ABNT NBR 10.004 储存 II B 类惰性废物",
      "score8": "非常显著 — 大坝按 ABNT NBR 10004 储存尾矿或 II A 类非惰性固体废物",
      "score10": "加重的非常显著 — 大坝按 ABNT NBR 10.004 储存尾矿或 I 类危险固体废物"
    },
    "dpaD": {
      "score0": "不存在 — 大坝下游受影响区域内不存在任何设施",
      "score1": "低 — 大坝下游受影响区域内存在少量具有文化社会经济意义的住宅、农业、工业或基础设施",
      "score3": "中 — 大坝下游受影响区域内存在中等集中度的具有文化社会经济意义的住宅、农业、工业或基础设施",
      "score5": "高 — 大坝下游受影响区域内存在高度集中的具有文化社会经济意义的住宅、农业、工业或基础设施"
    },
    "goA": {
      "score0": "证明最近 3 年内稳定",
      "score1": "证明最近一个半年度期间稳定",
      "score8": "未证明",
      "score10": "未提交"
    },
    "goB": {
      "score0": "证明最近 5 年内稳定",
      "score1": "证明最近一次提交所对应的稳定性",
      "score8": "未证明",
      "score10": "未提交"
    },
    "goC": {
      "score0": "证明最近 3 年内符合要求",
      "score1": "证明最近一年内符合要求",
      "score8": "未证明",
      "score10": "未提交"
    },
    "goD": {
      "score0": "最近 2 年内符合法定期限，且无异常记录 EC 评分 4、6 或 10",
      "score1": "最近一个半年度内符合法定期限，且无异常记录 EC 评分 4、6 或 10",
      "score2": "最近一个半年度内超出法定期限，或虽符合法定期限但有异常记录 EC 评分 4、6 或 10",
      "score6": "最近一个半年度内存在提交待办事项",
      "score10": "最近一个半年度内超过 4 份连续或间隔的摘要未提交"
    },
    "goE": {
      "score0": "已聘用注册工程师",
      "score1": "未聘用注册工程师（监管机构未要求）",
      "score10": "未聘用注册工程师（监管机构要求时）"
    },
    "goF": {
      "score0": "拥有 PGRBM",
      "score1": "没有 PGRBM（监管机构未要求）",
      "score4": "PGRBM 正在编制中",
      "score9": "没有 PGRBM（监管机构要求时）"
    },
    "goG": {
      "score0": "拥有 ISO 31.000 或采用 TSM 或 ICMM",
      "score1": "没有 ISO 31.000 或未采用 TSM 或 ICMM"
    }
  }
} as const;
